<template>
  <div :class="ThemeGet" class="content__module">
    <span :class="ThemeGet" class="light-text">StartPage</span>
  </div>
</template>

<script>
  export default {
    name: "Home",
    computed: {
      ThemeGet: function () {
        return this.$store.getters.ThemeGet;
      },
    },
  }
</script>

<style scoped>

</style>
